import { reportAppSessionStartedEvent } from '../actions/reporting';
import useOnMount from './useOnMount';
import useActions from './useActions';

const useSessionReporting = () => {
  const actions = useActions({ reportAppSessionStartedEvent });

  useOnMount(() => {
    actions.reportAppSessionStartedEvent();
  });
};

export default useSessionReporting;
